import * as types from "./actionType";
import {
    createLandlord
} from '../apis/axios'

export const setFormDataAction = (data) => ({
    type: types.SET_FORMDATA,
    payload: data
})

export const setSuccessAction = (data) => ({
    type: types.SET_SUCCESS,
    payload: data
})

export const submitFormDataAction = (data) => {

    return async (dispatch) => {
        try {
                dispatch(setSuccessAction({status: 'loading'}));
                const formData = new FormData();
                formData.append('form_data', JSON.stringify(data));
                const response = await createLandlord(formData);
                dispatch(setSuccessAction({
                    status: 'success',  
                    value: response.landlord_id
                }));
            } catch (error) {
                dispatch(setSuccessAction({status: 'error', value: error.response.data}));
            }
        }
}

